import { SearchServiceSort } from "../../hooks";

import request from "../base-request";

export interface IReviewAssignment {
	id: string;
	name: string;
	company?: object;
}

export interface IReviewAssignmentsData {
	assignments: IReviewAssignment[];
	count: Array<{ count: number }>;
}

export const fetchReviewAssignments = async (
	showOnlyOverdue,
	employeeNameSearchTerm,
	sort: SearchServiceSort,
	skip,
	limit
) => {
	let filters = "";

	if (showOnlyOverdue) {
		filters += "&has_overdue=true";
	}

	if (employeeNameSearchTerm) {
		filters += `&employee_name_search=${employeeNameSearchTerm}`;
	}

	if (skip) {
		filters += `&skip=${skip}`;
	}

	if (limit) {
		filters += `&limit=${limit}`;
	}

	if (sort) {
		filters += `&sortName=${sort.name}&sortDirection=${sort.direction}`;
	}

	const [data] = await request<IReviewAssignmentsData>(`/api/company/reviews/overview/?${filters}`);

	return data;
};
